import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink, Route, Routes, useNavigate } from "react-router-dom";
import pf from "./assets/images/icons/profile.png";
import msg from "./assets/imgs/msg.png";
import supp from "./assets/imgs/supp.png";
import user from "./assets/imgs/user.png";
import home from "./assets/imgs/home.png";
import employe from "./assets/imgs/employe.png";
import rendv from "./assets/imgs/rendezvous.png";
import agenda from "./assets/imgs/agenda.png";
import patient from "./assets/imgs/patient.png";
import Categorie from "./pages/Categorie";
import MonCompte from "./pages/MonCompte";
import Home from "./pages/Home";
import Product from "./pages/Product";
import Commande from "./pages/Commande";
import Client from "./pages/Client";
import Livreur from "./pages/Livreur";
import Fourniseur from "./pages/Fourniseur";
import Admin from "./pages/Admin";
import { deleteUser } from "./services/storage";
import { AppContext, initialUser } from "./services/context";
import Promotion from "./pages/Promotion";
import logo from "./assets/logo_v1.png";
import Marque from "./pages/Marque";
import Annee from "./pages/Annee";
import Model from "./pages/Model";
import Pays from "./pages/Pays";
import Vehicule from "./pages/Vehicule";
import VehiculeEnLocation from "./pages/VehiculeEnLocation";
import VehiculeEnVente from "./pages/VehiculeEnVente";
import Publicite from "./pages/Publicite";

const Dashboard = () => {
  const authCtx = useContext(AppContext);
  const { user, onUserChange } = authCtx;
  const navigate = useNavigate();

  useEffect(() => {
    isAuth();
  }, [user.isAuth]);

  const isAuth = () => {
    if (user.isAuth == false || user.token == null || user.token == "") {
      console.log(`connexion échoué, isAuth`);
      console.log(user);

      return navigate("/");
    } else {
      console.log("isAuth true");
    }
  };

  const deconnect = () => {
    deleteUser();
    onUserChange(initialUser);
    return navigate("/");
  };
  return (
    <>
      <header className="container-fluid navbar navbar-dark bg-white sticky-top flex-md-nowrap px-0 py-4 shadow1 d-md-none">
        <a
          className="navbar-brand1 bg-white col-md-3 col-lg-2 me-0 px-3"
          href="#"
        >
          <img width="64px" src={logo} alt="" />
        </a>
        <button
          className="navbar-toggler p-2 position-absolute mx-0 my-4 d-md-none collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#sidebarMenu"
          aria-controls="sidebarMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
      </header>

      <div className="container-fluid">
        <div className="row">
          <nav
            id="sidebarMenu"
            className="col-md-1 col-lg-2 d-md-block bg-white sidebar collapse p-0"
          >
            <div className="position-sticky h-100 text-small">
              <div className="col-12 d-none d-md-block text-center pt-4 pb-2 m-0">
                <img width={"100px"} src={logo} alt="" />
              </div>
              <div className="d-md-none py-2"></div>
              <ul className="nav flex-column">
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={home} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Accueil
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/marques"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={employe} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Marques
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/annees"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={employe} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Années
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/models"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={employe} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Models
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/categories"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={employe} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Catégories
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/pays"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={employe} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Pays
                    </span>
                  </NavLink>
                </li>
                {
                  /**
                   * <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/vehicules"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={rendv} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Vehicules
                    </span>
                  </NavLink>
                </li>
                   */
                }
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/vehicules-en-vente"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={rendv} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Vehicules en ventes
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/vehicules-en-location"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={rendv} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Vehicules en location
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/commandes"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={rendv} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Commandes
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/publicites"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={rendv} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Publicités
                    </span>
                  </NavLink>
                </li>
                {/**
                 * <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/promotions"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={rendv} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Promotions
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/agenda"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={agenda} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Commandes
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/patient"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={patient} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Clients
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/livreur"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={agenda} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Livreurs
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/fourniseur"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={agenda} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Fourniseurs
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/admin"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border-0 py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={agenda} alt="" />
                    </span>
                    <span
                      className="d-block d-md-none d-lg-block wd-80 p-0 m-0"
                      data-bs-toggle="collapse"
                      data-bs-target="#sidebarMenu.show"
                    >
                      Administrateurs
                    </span>
                  </NavLink>
                </li>
                 */}
              </ul>

              <ul className="nav flex-column w-100 position-absolute bottom-0 mb-2">
                <li className="nav-item my-1 px-2">
                  <NavLink
                    to="/dashboard/parametre"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-link active btn btn-primary border rounded-2 mx-auto py-0 text-start pt-1"
                        : "btn nav-link border py-0 btn-primary-light text-start pt-1"
                    }
                  >
                    <span className="d-none d-md-block d-lg-none wd-0">
                      <img src={supp} alt="" />
                    </span>
                    <span className="d-block d-md-none d-lg-block wd-80">
                      <span className="d-inline-block">
                        Paramètres du compte
                      </span>
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item my-1 px-2">
                  <span
                    className="btn nav-link border-0 py-0 btn-danger text-start pt-1"
                    onClick={deconnect}
                  >
                    Se déconnecter
                  </span>
                </li>
              </ul>
            </div>
          </nav>

          <main className="col-md-11 ms-sm-auto col-lg-10 px-md-4 pt-5 h-90 text-small">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/marques" element={<Marque />} />
              <Route path="/annees" element={<Annee />} />
              <Route path="/models" element={<Model />} />
              <Route path="/categories" element={<Categorie />} />
              <Route path="/pays" element={<Pays />} />
              <Route path="/vehicules" element={<Vehicule />} />
              <Route path="/vehicules-en-vente" element={<VehiculeEnVente />} />
              <Route path="/vehicules-en-location" element={<VehiculeEnLocation />} />
              <Route path="/commandes" element={<Commande />} />
              <Route path="/publicites" element={<Publicite />} />

              <Route path="/produits" element={<Product />} />
              <Route path="/promotions" element={<Promotion />} />
              <Route path="/agenda" element={<Commande />} />
              <Route path="/patient" element={<Client />} />
              <Route path="/livreur" element={<Livreur />} />
              <Route path="/fourniseur" element={<Fourniseur />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/parametre" element={<MonCompte />} />
            </Routes>
          </main>
          <div className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="text-small d-inline-block my-4 me-4">
              Copyright © 2025 MOBILISSO
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
